<div class="container d-flex direction-column align-center mt-2 mb-2">
  <div
    class="container-content content d-flex direction-column align-center justify-space-between"
    [ngClass]="{ 'container-expand': bodyExpanded }"
  >
    <div class="content-card card d-flex align-center justify-space-between column-gap-10"
         [ngClass]="{
         'cursor-pointer' :
         contract.Beneficiaries && contract.Beneficiaries.length>
      1
      }"
      [attr.role]="contract.Beneficiaries && contract.Beneficiaries.length > 1 ? 'button' : null"
      [attr.tabindex]="contract.Beneficiaries && contract.Beneficiaries.length > 1 ? '0' : null"
      (click)="
      contract.Beneficiaries &&
      contract.Beneficiaries.length > 1 &&
      (bodyExpanded = !bodyExpanded);
      $event.stopPropagation()
      "
      (keydown.enter)="
      contract.Beneficiaries &&
      contract.Beneficiaries.length > 1 &&
      (bodyExpanded = !bodyExpanded)
      "
      (keydown.space)="
      contract.Beneficiaries &&
      contract.Beneficiaries.length > 1 &&
      (bodyExpanded = !bodyExpanded)
      "
      >
      <div class="card-data data" style="width: 20px; text-align: left">
        <span class="data-generic">{{linha}}</span>
      </div>

      <div class="card-data data flex-1">
        <ng-content select="[cardFlag]"></ng-content>
      </div>

      <div class="card-data data flex-2">
        <span class="data-primary bank">
          {{ (contract.FinancialInstitution | titlecase) || "-" }}
        </span>
        <span class="data-secondary">
          {{ (contract.Chanel | titlecase) || "-" }}
        </span>
      </div>

      <div class="card-data data flex-2">
        <span class="data-primary">{{ contract.Number || "-" }}</span>
        <span class="data-secondary">{{ contract.Version ? '(v. ' + contract.Version + ')' : '-' }}</span>
      </div>

      <div class="card-data data flex-4"
           [matTooltip]="contract.BeneficiaryName">
        <span class="data-primary">
          {{ (contract.BeneficiaryName | titlecase) || "-" }}
        </span>
        <span class="data-secondary">
          {{ (contract.BeneficiaryType | titlecase) || "-" }}
        <span *ngIf="isStoreConfig && contract.Beneficiaries && contract.Beneficiaries.length > 1"
              class="ml-5 plus-icon">+</span>
        </span>
        <span *ngIf="isReverseContract" class="reverse-badge ml-5">Estorno</span>
        
      </div>

      <div class="card-data data flex-4" [matTooltip]="contract.Client || ''">
        <span class="data-primary">
          {{ (contract.Client | titlecase) || "-" }}
        </span>
        <span class="data-secondary"
              [matTooltip]="contract.ClientDocument || ''">
          {{ (contract.ClientDocument | titlecase) || "-" }}
        </span>
      </div>

      <div class="card-data data flex-3"
           [matTooltip]="
          contract.Amount.toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }) || ''
        ">
        <span class="data-primary" [ngClass]="{ reversed: isReverseContract }">
          {{ (contract.Amount | currency : "BRL") || "-" }}
        </span>
        <span class="data-secondary">{{ contract.BeneficiaryFee + '%' || '-' }}</span>
      </div>

      <div class="card-data data flex-3">
        <span class="data-status status" [ngClass]="{ reversed: isReverseContract }">
          {{ (contract.Status | titlecase) || "-" }}
        </span>
        <span class="data-secondary">{{ contract.Subsidiary || '-' }}</span>
      </div>

      <div class="card-data data flex-4">
        <span class="data-primary">
          {{ contract.ProductionDate ? (contract.ProductionDate | date : "dd/MM/yyyy") : "-" }}
        </span>
        <span class="data-secondary">
          Lote {{ contract.InvoiceBatchNumber || '-' }} • {{ (contract.InvoiceBatchStatus | titlecase) || '-' }}
        </span>
      </div>

      <div class="card-expand expand">
        <button *ngIf="isStoreConfig"
                class="d-flex align-center justify-center expand-btn btn-icon">
          <app-svg-icon class="card-expand-svg"
                        src="assets/icons/arrow-icon.svg"
                        alt="expand"
                        width="8px"
                        color="arrowGray"></app-svg-icon>
        </button>
      </div>
    </div>

    <div
      [ngClass]="{ 'content-divider': bodyExpanded }"
      class="divider d-flex justify-start"
    ></div>

    <div
      *ngIf="isStoreConfig"
      class="content-body body d-flex align-flex-start direction-column"
    >
      <div
        *ngFor="let beneficiary of contract.Beneficiaries"
        class="d-flex vw-50 ptb-5"
      >
        <span class="flex-1 body-title"
          >Beneficiário:
          <span class="body-text ml-8">{{ beneficiary.Name }}</span></span
        >
        <span class="flex-1 body-title"
          >Tipo:
          <span class="body-text ml-8">{{ beneficiary.Type }}</span></span
        >
        <span class="flex-1 body-title"
          >Comissão:
          <span class="body-text ml-8">{{ beneficiary.Fee }}%</span></span
        >
      </div>
    </div>
  </div>
</div>
